<template>
  <div class="Index">
    <bannerSection></bannerSection>
    <!-- ================================================正式内容===================================================== -->
    <!-- Header Section Component -->
    <header-section></header-section>

    <!-- Magazine Modules Section Component -->
    <magazine-modules-section></magazine-modules-section>

    <!-- Features Section Component -->
    <features-section></features-section>

    <featured-product-section></featured-product-section>

    <!-- Blog Post Layouts Section Component -->
    <blog-layouts-section></blog-layouts-section>

    <!-- Statistics Section Component -->
    <statistics-section></statistics-section>

    <!-- Theme Preview Section Component -->
    <theme-preview-section></theme-preview-section>

    <!-- Video Section Component -->
    <video-section></video-section>

    <!-- Latest Blogs Section Component -->
    <!-- <latest-blogs-section></latest-blogs-section> -->
    
    <!-- Add floating banner at the bottom of the page -->
    <floating-banner></floating-banner>
  </div>
</template>

<script>
import bannerSection from "./bannerSection";
import headerSection from "./headerSection";
import magazineModulesSection from "./magazineModulesSection";
import featuresSection from "./featuresSection";
import featuredProductSection from './featuredProductSection'
import blogLayoutsSection from "./blogLayoutsSection";
import statisticsSection from "./statisticsSection";
import themePreviewSection from "./themePreviewSection";
import videoSection from "./videoSection";
import floatingBanner from "./floatingBanner"
// import latestBlogsSection from "./latestBlogsSection";
// import caImage from "@/assets/web_pg_ca.png";
// import Isvg from "@/page/index/ISvg";
export default {
  name: "Index",
  components: {
    // Isvg,
    bannerSection,
    headerSection,
    magazineModulesSection,
    featuresSection,
    featuredProductSection,
    blogLayoutsSection,
    statisticsSection,
    themePreviewSection,
    videoSection,
    floatingBanner
    // latestBlogsSection,
  },
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/Index.vue